<template>
  <div :key="key">
    <v-expansion-panels v-model="openedModule">
      <v-expansion-panel v-for="moduleName in Object.keys($module.all)" :key="moduleName">
        <v-expansion-panel-header>
          <v-row no-gutters style="line-height: 24px;">
            <v-col>
              <v-icon style="flex: none" class="mr-1">{{ $module.all[moduleName].display.icon }}</v-icon>
              {{ $module.all[moduleName].display.name }}
            </v-col>
            <v-col>
              <div v-if="$account.getSubscription(moduleName).name === 'default'">
                <v-chip small color="default">{{ $t('no-subscription') }}</v-chip>
              </div>
              <div v-else>
                <v-chip small color="success">{{ $t('subscription') }}
                  {{ $module.all[moduleName].plan.list[$account.getSubscription(moduleName).name].label }}
                </v-chip>
              </div>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-tabs-items v-model="subscribe[moduleName]">
            <v-tab-item>
              <subscription-plan
                :plan="$account.getSubscription(moduleName).name"
                :module="moduleName"
                :readonly="true">
                <template v-slot:actions="props">
                  <div v-if="$account.getSubscription(moduleName).name === 'default'">
                    <v-btn text color="success" @click="subscribe[moduleName] = 1">
                      {{ $t('actions.subscriptions.subscribe') }}
                    </v-btn>
                  </div>
                  <div v-else>
                    <v-alert type="warning" text border="left"
                             v-if="!['active', 'trialing'].includes($account.getSubscription(moduleName).status)">
                      {{ $t('alert-payment') }}
                    </v-alert>

                    <v-btn
                      v-if="props.subscription.ends_at === null"
                      @click="openTerminateDialog(props.subscription)"
                      text color="error">
                      {{ $t('actions.subscriptions.cancel') }}
                    </v-btn>
                    <v-btn
                      v-else
                      @click="openResumeDialog(props.subscription)"
                      text color="warning">
                      {{ $t('actions.subscriptions.cancel-cancellation') }}
                    </v-btn>

                    <v-btn
                      v-if="['incomplete', 'past_due'].includes(props.subscription.status)"
                      @click="openConfirmPaymentDialog(props.subscription)"
                      text color="warning">
                      {{ $t('actions.subscriptions.confirm-payment') }}
                    </v-btn>
                    <v-btn
                      v-else
                      text
                      color="success"
                      @click="subscribe[moduleName] = 1">
                      {{ $t('actions.subscriptions.edit') }}
                    </v-btn>
                  </div>
                </template>
              </subscription-plan>
            </v-tab-item>
            <v-tab-item>
              <div v-for="plan in getModuleSelectablePlans(moduleName)" :key="plan.name">
                <subscription-plan :plan="plan.name" :module="moduleName">
                  <template v-slot:actions="props">
                    <v-btn text color="grey" @click="subscribe[moduleName] = 0">{{ $t('actions.cancel') }}</v-btn>
                    <v-btn
                      v-if="props.subscription.status === 'order'"
                      @click="openSubscribeDialog(props.subscription)"
                      text color="success">
                      {{ $t('actions.subscriptions.subscribe') }}
                    </v-btn>
                    <span v-else-if="['active', 'trialing'].includes(props.subscription.status)">
                      <v-btn
                        @click="openChangeDialog(props.subscription)"
                        :disabled="!props.subscription.hasModifications()"
                        text color="success">
                        {{ $t('actions.edit') }}
                      </v-btn>
                    </span>

                  </template>
                </subscription-plan>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import { camelCase, startCase } from 'lodash'
import SubscriptionPlan from '../Subscription/SubscriptionPlan'

export default {
  name: 'SubscriptionsPage',
  components: { SubscriptionPlan },
  data () {
    return {
      key: true,
      unwatch: null,
      subscribe: {
        'check-position': 0,
      },
      openedModule: 0
    }
  },
  methods: {
    openSubscribeDialog (subscription) {
      this.$bus.emit('dialog/subscribe_to_plan/open', subscription)
    },
    openChangeDialog (subscription) {
      this.$bus.emit('dialog/change_plan/open', subscription)
    },
    openConfirmPaymentDialog (subscription) {
      this.$bus.emit('dialog/confirm_payment/open', subscription)
    },
    openTerminateDialog (subscription) {
      this.$bus.emit('dialog/terminate_plan/open', subscription)
    },
    openResumeDialog (subscription) {
      this.$bus.emit('dialog/resume_plan/open', subscription)
    },
    getModuleSelectablePlans (module) {
      return Object.values(this.$module.all[module].plan.list)
        .filter(plan => plan.selectable === true)
    },

    hasComponent (name) {
      return startCase(camelCase(name)).replace(/ /g, '') in this.$options.components
    },
  },
  mounted () {
    // Fix for subscriptions not refreshing ... because of this.$models.Subscription.get() breaking reactivity
    this.unwatch = this.$watch(() => {
      return this.$account.current.customer
    }, () => {
      this.subscribe['check-position'] = 0
      this.openedModule = 0
      this.key = !this.key
    })
  },
  destroyed () {
    this.unwatch()
  }
}
</script>

<i18n>
{
	"en": {
		"alert-payment": " The automatic payment has been refused by your bank, please confirm the payment with your bank card below.",
		"no-subscription": "No subscription",
		"subscription": "Subscription :",
		"subscription-offer": "Subscribe to an offer"
	},
	"es": {
		"alert-payment": " Su banco ha rechazado el pago automático. Confirme el pago con su tarjeta bancaria a continuación.",
		"no-subscription": "Sin subscripción",
		"subscription": "Suscripción :",
		"subscription-offer": "Suscríbete a una oferta"
	},
	"fr": {
		"alert-payment": " Le paiement automatique a été refusé par votre banque, merci de confirmer ci-dessous le paiement avec votre carte bancaire.",
		"no-subscription": "Aucune souscription",
		"subscription": "Souscription :",
		"subscription-offer": "Souscrire à une offre"
	},
	"it": {
		"alert-payment": " Il pagamento automatico è stato rifiutato dalla tua banca, conferma il pagamento con la tua carta bancaria qui sotto.",
		"no-subscription": "Nessun abbonamento",
		"subscription": "Abbonamento :",
		"subscription-offer": "Abbonati a un'offerta"
	},
	"pt": {
		"alert-payment": " O pagamento automático foi recusado pelo seu banco, por favor confirme o pagamento com o seu cartão bancário abaixo.",
		"no-subscription": "Sem subscrição",
		"subscription": "Subscrição :",
		"subscription-offer": "Subscrever uma oferta"
	},
	"pl": {
		"alert-payment": " Automatyczna płatność została odrzucona przez Twój bank, proszę potwierdź płatność kartą bankową poniżej.",
		"no-subscription": "Brak subskrypcji",
		"subscription": "Subskrypcja :",
		"subscription-offer": "Subskrybuj ofertę"
	}
}
</i18n>
